<template>
    <div>
        <div class="p-4 bg-white shadow-sm rounded-lg overflow-hidden">
            <h6 class="text-center mb-4">Select transaction to use as template for new transaction</h6>
            <div class="list-group rounded-lg">
                <div v-for="batch in data.content.data"
                     @mouseenter="batchOver = batch.ref"
                     @mouseleave="batchOver = null"
                     class="list-group-item list-group-item-action d-flex align-items-center">
                    <div class="d-inline-block text-left">
                        <h6 class="mb-1">
                            <span class="mr-2">Transaction #{{ batch.code }}</span>
                            <strong>{{ batch.currency }} {{ batchTotal(batch) }}</strong>
                        </h6>
                        <p class="small mb-0">
                            {{ new Date(batch.created_at).toLocaleDateString() }} &bull;
                            {{ batch.meta.success }} Successful &bull;
                            {{ batch.meta.failed }} Failed
                        </p>
                    </div>
                    <div class="d-inline-block text-right ml-auto">
                        <router-link
                            v-if="batchOver === batch.ref"
                            :to="`/business/create?copy=${batch.ref}`"
                            class="btn btn-sm btn-primary">
                            <i class="fa fa-copy"></i>
                            Use this transaction
                        </router-link>
                    </div>
                </div>
            </div>
        </div>
        <div class="card-footer bg-white text-center">
            <router-link to="/business/transact" class="btn btn-link shadow-none">
                Start Again?
            </router-link>
        </div>
    </div>
</template>

<script>

import Data from "../../../core/data/Data";

export default {
    name: "BusinessInitHistory",
    data() {
        return {
            data: new Data({
                url: "/business/batches/list",
                prefix: "list"
            }),
            batchOver: null
        };
    },
    methods: {
        batchTotal(batch) {
            let total = 0;
            const toNumber = t => {
                let number = parseFloat(t.amount);

                return isNaN(number) ? 0 : number;
            }
            const reducesTo = (prev, current, index) => parseFloat(prev) + parseFloat(current);

            if (batch.zesa) {
                total += batch.zesa.transactions.map(toNumber).reduce(reducesTo)
            }

            if (batch.bundle) {
                total += batch.bundle.transactions.map(toNumber).reduce(reducesTo)
            }

            if (batch.airtime) {
                total += batch.airtime.transactions.map(toNumber).reduce(reducesTo)
            }

            if (batch.smart) {
                total += batch.smart.transactions.map(toNumber).reduce(reducesTo)
            }

            if (isNaN(total)) return '--.--'

            return total.toFixed(2)
        }
    },
    mounted() {
        this.data.fetch()
    }
}
</script>
